export function getVenueDashboardUrl(venueId) {
  return `/v/${venueId}/home`
}

export function openVenueDashboard(venueId, target = '_blank') {
  if (!venueId) {
    throw new Error('Venue ID is required')
  }

  const url = getVenueDashboardUrl(venueId)
  window.open(url, target, 'noopener,noreferrer')
}
